import {createFeatureSelector, createSelector} from "@ngrx/store";
import {TechRegisterState} from "./tech-register.state";

export const techRegisterSelect = createFeatureSelector<TechRegisterState>('techRegister');

export const selectIsLoading = createSelector(
  techRegisterSelect,
  (state: TechRegisterState) => state.isLoading
);
